import { withStyles } from '@material-ui/core/styles'
import Accordion from '@material-ui/core/Accordion'

const CustomExpansionPanel = withStyles({
  root: {
    marginLeft: '16px !important',
    marginRight: '16px !important',
    '&:before': {
      height: 0
    },
  }
})(Accordion)

export const NestedCustomExpansionPanel = withStyles({
  root: {
    boxShadow: 'none',
    marginTop: 0,
    paddingLeft: 3
  }
})(CustomExpansionPanel)

export default CustomExpansionPanel
